var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookmyshow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11154_89197)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.111084,
    y: 0.111115,
    width: 53.7778,
    height: 53.7778,
    fill: "url(#paint0_linear_11154_89197)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0578 20.0378L40.2933 16.9543L37.1564 18.505L35.3918 15.4215L32.2549 16.9722L30.4904 13.8887L27.3534 15.4393L25.5889 12.3559L22.452 13.9065L20.6874 10.8231L17.5505 12.3737L10.8667 34.6887L18.9586 37.2375C19.4933 35.4373 21.133 34.1184 23.058 34.1184C25.4285 34.1184 27.3534 36.0968 27.3534 38.5386V38.6277C27.3713 39.0198 27.3356 39.4298 27.2108 39.8219L35.4453 42.4241",
    fill: "#D70B17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8 32.8351C17.3722 32.7638 17.087 32.3895 17.087 31.9439V20.9825C17.087 20.4656 17.4792 20.0735 17.9782 20.0735H25.6423C25.8384 20.0735 26.0344 20.0913 26.2305 20.127C27.8702 20.43 29.0822 21.8915 29.0822 23.6204V31.9439C29.0822 32.1935 28.9931 32.4252 28.8149 32.6034C28.6545 32.7638 28.4228 32.8708 28.1911 32.8708L28.0307 32.8529C27.6029 32.7816 27.3177 32.4073 27.3177 31.9618V23.656C27.3177 22.8183 26.7295 22.1054 25.9275 21.9628L25.6423 21.9271H23.9669V31.9618C23.9669 32.2113 23.8778 32.443 23.6996 32.6212C23.5391 32.7816 23.3074 32.8886 23.0757 32.8886L22.9153 32.8708C22.4876 32.7995 22.2024 32.4252 22.2024 31.9796V21.9271H18.8516V31.9618C18.8516 32.2113 18.7624 32.443 18.5842 32.6034C18.4238 32.7638 18.1921 32.8708 17.9604 32.8708L17.8 32.8351Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5438 37.6118C30.116 37.5405 29.8308 37.1662 29.8308 36.7206C29.8308 36.4711 29.9199 36.2394 30.0803 36.079C30.2407 35.9186 30.4725 35.8116 30.7042 35.8116C31.4527 35.8116 32.0944 35.3126 32.3083 34.5818L33.2173 31.4449L30.2407 21.1607C30.0982 20.6795 30.3655 20.1626 30.8289 20.0022L31.221 19.9844C31.5419 20.0378 31.8092 20.2874 31.9162 20.6082L34.1263 28.2723L36.372 20.6082C36.479 20.1804 36.9246 19.8952 37.388 19.9844L37.4414 20.0022C37.9227 20.1626 38.19 20.6795 38.0296 21.1607L34.964 31.7122L34.0015 35.0987C33.752 35.8829 33.3242 36.5067 32.7539 36.9345C32.1479 37.3979 31.4349 37.6474 30.6863 37.6474L30.5438 37.6118Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11154_89197",
    x1: 27,
    y1: 0.111115,
    x2: 27,
    y2: 53.8889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#373D59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202546"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11154_89197"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.111084,
    y: 0.111115,
    width: 53.7778,
    height: 53.7778,
    rx: 4.88889,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmyshow);
export default __webpack_public_path__ + "static/media/bookmyshow.9904e43994acb67d2010fa968c755fbd.svg";
export { ForwardRef as ReactComponent };